Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useStyles = void 0;
var _reactNative = require("react-native-web");
var _styles = require("../../styles");
var useStyles = exports.useStyles = function useStyles() {
  var _STYLES$useStyles = _styles.STYLES.useStyles(),
    spacing = _STYLES$useStyles.spacing,
    container = _STYLES$useStyles.container,
    container_noHeader = _STYLES$useStyles.container_noHeader;
  var heading = {
    textAlign: 'center'
  };
  var filterGroup = {
    marginBottom: spacing.l,
    maxWidth: _styles.STYLES.grid.maxTextWidth,
    alignSelf: 'center'
  };
  var activityIndicator = {
    marginTop: spacing.xl,
    marginBottom: spacing.xxxl
  };
  var list = {
    marginTop: spacing.xl
  };
  var tabs = {
    marginBottom: spacing.xxxl
  };
  var styles = _reactNative.StyleSheet.create({
    container: container,
    container_noHeader: container_noHeader,
    heading: heading,
    filterGroup: filterGroup,
    activityIndicator: activityIndicator,
    list: list,
    tabs: tabs,
    section: {
      marginBottom: spacing.xxxl
    }
  });
  return {
    styles: styles
  };
};